<template>
  <div class="text-sidebar">
    <div class="text-sidebar__main">
      <div class="text-sidebar__head">
        <!-- TITLE -->
        <h2 class="text-sidebar__title">Comment faire ?</h2>
      </div>
      <div class="text-sidebar__content">
        <div class="text-sidebar__left">
          <div class="text-sidebar__text">
            <!-- TEXT -->
            <p><strong>Le processus est très simple.</strong> Il suffit de
            communiquer votre numéro BCE pour identifier votre
            secteur d'activité et les principales caractéristiques de votre
            entreprise.</p>
            <p><strong>Vous devrez alors répondre à un questionnaire en
            ligne.</strong> Celui-ci est basé sur le même modèle que le baromètre global de maturité numérique des entreprises wallonnes réalisé tous les 2 ans par l'Agence du Numérique.</p>
            <p>Ce processus prendra environ 30 minutes, sans préparation particulière.</p>
            <p>A la fin du questionnaire, vous recevrez :</p>
            <ul>
              <li>Le DigiScore de maturité numérique de votre entreprise et
              son détail suivant 4 axes spécifiques : infrastructure technologique, ressources humaines, digitalisation des processus et stratégie
              commerciale.</li>
              <li>La comparaison de ces scores avec l'ensemble des entreprises wallonnes et les entreprises
              présentant les mêmes   caractéristiques (taille, secteur, export,
              mono/multi-sites, localisation, etc.).</li>
              <li>Des recommandations et des ressources pour vous permettre de passer à l'action.</li>
            </ul>
          </div>
          <div class="paragraph-item__button">
            <a href="#" class="btn btn-gradient" @click="goToSurvey">J’inscris mon entreprise maintenant</a>
          </div>
        </div>
        <div class="text-sidebar__side">
          <!-- SIDE BLOCK -->
          <div class="side-block">
            <div class="side-block__picture">
              <img srcset="@/assets/images/picture-home-2.jpg 623w,
                @/assets/images/picture-home-2@2x.jpg 1246w"
                sizes="(max-width: 480px) 240px,
                800px"
                src="@/assets/images/picture-home-2.jpg" />
            </div>
            <div class="side-block__content">
              <h3 class="side-block__title">Mesurer votre maturité numérique et calculer votre Digiscore</h3>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import goToSurveyMixin from '@/mixins/goToSurvey';

export default {
  name: 'TextSidebar',
  mixins: [goToSurveyMixin],
};
</script>
